module.exports = __webpack_public_path__ + "assets/images/airports-sg/desktop.svg?v=304e2a64";